import { render, staticRenderFns } from "./BandejaFechaComponente.vue?vue&type=template&id=c8c0ec28"
import script from "./BandejaFechaComponente.vue?vue&type=script&lang=js"
export * from "./BandejaFechaComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports